<template>
    <div>
        <template v-if="manage_meta_data == true">
            <div class="page-top mb-1 mb-3">
                <h1> Edit MetaData </h1>
            </div>
            <div class="global-main">
                <form id="onboardingDocumentForm" @submit.prevent="updateOnboardingDocument" novalidate>
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label>Key<em class="required">*</em></label>
                            <input :disabled="form.key" v-model="form.key" type="text" name="key" class="form-control" :class="{ 'is-invalid': form.errors.has('key') }" maxlength="50">
                            <has-error :form="form" field="key"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Value <em class="required">*</em></label>
                            <input v-model="form.value" type="text" name="value" class="form-control" :class="{ 'is-invalid': form.errors.has('value') }" maxlength="150">
                            <has-error :form="form" field="value"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Comment <em class="required">*</em></label>
                            <input v-model="form.comment" type="text" name="comment" class="form-control" :class="{ 'is-invalid': form.errors.has('comment') }" maxlength="150">
                            <has-error :form="form" field="comment"></has-error>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/manageMetaDataComponent" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="manage_meta_data === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="manage_meta_data === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                form: new Form({
                    key: null,
                    value: "",
                    comment: "",
                    created_at:"",
                    updated_at: ""

                }),
                manage_meta_data: null,
            };
        },
        methods: {
            updateOnboardingDocument() {
                let newForm=new FormData();
                $.each(this.form, (key, value) => {
                    if (key !== 'busy' && key !== 'successful' && key !== 'errors' &&   key !== 'originalData') {
                        newForm.append(key, value);
                    }
                });
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                axios.post('/api/addEditMetaData',newForm, config)
                .then(res => {
                    if(res.status == 200){
                        if(res.data.code == '200'){
                            this.showToastBox("success", "The records have been successfully updated");
                            this.$router.push("/manageMetaDataComponent");
                            this.$Progress.finish();
                        }else{
                            var error_msg = '';
                            error_msg = 'Please provide following details:'+'\n';     
                            $.each(res.data.data, (key, value) => {
                                error_msg += value +'\n';     
                            });
                            this.showAlertBox('error',error_msg);
                            this.$Progress.fail();
                        }
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    }
                }).then(res=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(errors => {
                    const errorMessages = Object.entries(errors.response.data.errors)
                        .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
                        .join('\n');
                    this.showAlertBox('error', `Validation errors:\n${errorMessages}`);
                });
            },
            getOnboardingDocumentData() {
                axios.get("/api/getSingleMetaData/" + this.$route.params.id)
                    .then((res) => {
                        if (res.data.code == 200) {
                            this.form.key = res.data.data.key;
                            this.form.value = res.data.data.value;
                            this.form.comment = res.data.data.comment;
                            this.form.created_at = res.data.data.created_at;
                            this.form.updated_at = res.data.data.updated_at;
                        } else {
                            this.$Progress.fail();
                            this.showAlertBox("error", "Some error in your form data");
                        }
                    })
                    .catch((err) => {
                        this.$Progress.fail();
                        this.showAlertBox("error", "Some error in your form data");
                    });
            },
        },
        mounted() {
            this.$Progress.start();
            this.can("manage_meta_data")
                .then((result) => {
                    this.manage_meta_data = result.manage_meta_data;
                })
                .then((result) => {
                    if (this.manage_meta_data == true) {
                        $('#sample_file_div').hide();
                        this.getOnboardingDocumentData();
                        this.$Progress.finish();
                    } else {
                        this.$Progress.finish();
                    }
                });
        },
    }
</script>
